import { retry } from "rxjs"
import { States } from "../../enums/States"
import { ModulesManagerService } from "../Module/modules-manager.service"

export class StatsCalculator {
    private module : string = ""
    private id : number = 0
    private single : any = []
    private ready = false
    private colorScheme :any = {
        domain: []
    }

    constructor(private manager : ModulesManagerService,module : string, id : number) {
        this.module = module
        this.id = id
        for(const [key, state] of Object.entries(States)){
            if(!Number.isInteger(parseInt(key))) continue;
            this.colorScheme.domain[key] = (getComputedStyle(document.querySelector("body")).getPropertyValue('--state-'+key));        
        }
    }

    public async calculate() {
        this.Ready = false
        let stats = await  this.manager.Ws.Send(this.module, "GetStats", {Id : this.id}, true)
        let updatedSingle = this.single.map(item => ({ ...item })); // Create a new array
        for(const [prop, stat] of (Object.entries(stats.Data) as Array<[string, any]>)){
            stat.name = this.manager.Trad.Parse(stat.name)          
           updatedSingle[parseInt(prop)] = stat
        }        
        this.single = updatedSingle
        this.Ready = true
    }

    public get Single() {
        return  this.single 
    }

    public get ColorScheme() {
        return  this.colorScheme
    }

    public get Ready(){
        return this.ready
    }

    public set Ready(value){
        this.ready = value
    }
    
}
